// localize the requires here
/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */
export const logoClockWhite: string = require("./logo_clockwise-clock-white.svg");
export const logoClock: string = require("./logo_clockwise-clock.svg");
export const logoVertical: string = require("./logo_clockwise-vertical.svg");
